import React, { useState, useEffect } from 'react';
import { Avatar } from '@mui/material';
import { Person } from '@mui/icons-material';
import { useUGC } from '../contexts/UGCContext';

const CharacterAvatar = ({ 
  profilePictureUrl, 
  characterName, 
  size = 80, 
  sx = {},
  isRecent = false,
  isAdmin = false,
  isDeceased = false,
  ...props 
}) => {
  const [imageError, setImageError] = useState(false);
  const { getImageUrl } = useUGC();

  // Reset error state when profile picture URL changes
  useEffect(() => {
    setImageError(false);
  }, [profilePictureUrl]);

  const defaultColor = isRecent ? '#4caf50' : '#2196f3';
  
  const handleImageError = () => {
    setImageError(true);
  };

  // Get UGC-aware image URL (returns null if UGC disabled and user not admin)
  const imageUrl = getImageUrl(profilePictureUrl, isAdmin);

  // If there's a valid profile picture URL and no error, show the image
  const showProfilePicture = imageUrl && !imageError;

  const avatarContent = (
    <Avatar
      sx={{
        width: size,
        height: size,
        bgcolor: showProfilePicture ? 'transparent' : defaultColor,
        fontSize: size > 60 ? '2rem' : '1.5rem',
        ...sx
      }}
      {...props}
    >
      {showProfilePicture ? (
        <img
          src={imageUrl}
          alt={characterName || 'Character'}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '50%',
            filter: isDeceased ? 'grayscale(50%)' : 'none'
          }}
          onError={handleImageError}
        />
      ) : (
        <Person fontSize={size > 60 ? "large" : "medium"} />
      )}
    </Avatar>
  );

  // Return avatar without badge - deceased status shown via chips in parent components
  return avatarContent;
};

export default CharacterAvatar; 